/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useHistory } from "react-router-dom";
import {
  Nav,
  NavItem,
  TopIcon,
  Span,
  Div,
  SubNavItem,
  UL,
  ListItem,
} from "./styles";
// import ReactDOM from "react-dom";
import { FaUsers } from "react-icons/fa";
import { BsCalendar4 } from "react-icons/bs";
import { IoWalletOutline } from "react-icons/io5";
import {
  FiFilePlus,
  FiSettings,
  FiChevronRight,
  FiChevronDown,
} from "react-icons/fi";
import ScheduleNav from "./ScheduleNav";
import BillingNav from "./BillingNav";
import ReportNav from "./ReportNav.js";
import SettingsNav from "./SettingsNav";
import { MdMonitor } from "react-icons/md";
import { MdOutlineDashboard } from "react-icons/md";
import ExploreWidget from "./ExploreWidget";
import Greaterthan from "../../assets/images/Greaterthan.png";
import Greaterthanopp from "../../assets/images/Greaterthanopp.png";
import UnLoadScripts from "../popups/unLoadScript";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { GetNav } from "../../StateManagement/Reducers/ScheduleState";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { globalColor } from "../utils/RepeatFunctions/Schedule";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "../popups/GetStartedPopup.js";
import {
  getHighlightStyles,
  getItemHighlightStyles,
} from "../setting/HighlightConstants.js";
import { setGetStarted } from "../../StateManagement/Reducers/GetStartedState.js";
import { MdOutlineViewQuilt } from "react-icons/md";
import headphoneIcon from "../../assets/images/HeadphoneSidenav.svg";

// Generic scroll-lock hook — walks up from `targetRef` to find the
// nearest scrollable ancestor (via getScrollableParent) and freezes it
// (re-pinning scrollTop on wheel/touch/scroll) for as long as `isActive`
// is true. Same mechanism already used for the Batch Eligibility (28.1)
// and Macro Buttons (29.1) nav popups, generalized so it can be reused
// for any guided-tour popup in the sidebar.
const useNavPopupScrollLock = (
  isActive,
  targetRef,
  getScrollableParent,
  delay = 450,
) => {
  const scrollParentRef = useRef(null);
  const scrollTopRef = useRef(0);

  useEffect(() => {
    if (!isActive) return;

    let cleanupScrollLock = null;

    const timer = setTimeout(() => {
      const scrollParent = getScrollableParent(targetRef.current);
      if (!scrollParent) return;

      scrollParentRef.current = scrollParent;
      scrollTopRef.current = scrollParent.scrollTop;

      const previousOverflowY = scrollParent.style.overflowY;
      const previousOverscrollBehavior = scrollParent.style.overscrollBehavior;

      scrollParent.style.overflowY = "hidden";
      scrollParent.style.overscrollBehavior = "contain";

      const lockScroll = (e) => {
        const isZoomGesture =
          e.ctrlKey || e.metaKey || (e.touches && e.touches.length > 1);

        if (isZoomGesture) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        if (scrollParentRef.current) {
          scrollParentRef.current.scrollTop = scrollTopRef.current;
        }
      };

      const keepScrollFixed = () => {
        if (scrollParentRef.current) {
          scrollParentRef.current.scrollTop = scrollTopRef.current;
        }
      };

      scrollParent.addEventListener("wheel", lockScroll, {
        passive: false,
        capture: true,
      });
      scrollParent.addEventListener("touchmove", lockScroll, {
        passive: false,
        capture: true,
      });
      scrollParent.addEventListener("scroll", keepScrollFixed, true);

      cleanupScrollLock = () => {
        scrollParent.removeEventListener("wheel", lockScroll, true);
        scrollParent.removeEventListener("touchmove", lockScroll, true);
        scrollParent.removeEventListener("scroll", keepScrollFixed, true);

        scrollParent.style.overflowY = previousOverflowY;
        scrollParent.style.overscrollBehavior = previousOverscrollBehavior;

        scrollParentRef.current = null;
      };
    }, delay);

    return () => {
      clearTimeout(timer);
      if (cleanupScrollLock) {
        cleanupScrollLock();
      }
    };
  }, [isActive, targetRef, getScrollableParent, delay]);

  return scrollParentRef;
};

const SideNav = () => {
  // ------------------------------ State and Variables start--------------------------------------------------- //
  const permission = localStorage.getItem("setroles");
  const decryptedPermission = Decrypt_Value(permission, "vozo");
  const [isOpen, setIsOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState("");
  const [showPatientSubMenu, setShowPatientSubMenu] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const timeoutRef = useRef(null);
  const navRef = useRef(null);
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const step = query.get("step");

  console.log("step", step);

  const [widgetPos, setWidgetPos] = useState(null);

  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const location1 = useLocation();
  const history = useHistory();
  const [isIntroOpen, setIsIntroOpen] = useState(false);
  const [showStepFourIntro, setShowStepFourIntro] = useState(false);
  const [isMembershipPopupOpen, setIsMembershipPopupOpen] = useState(false);
  const navItemRef = useRef(null);
  const membershipPlanRef = useRef(null);
  const patientGroupRef = useRef(null);
  const highlightinsclaim = useRef(null);

  const headphoneRef = useRef(null);
  const isTemplatesPage =
    splitLocation[1] === "settings" && splitLocation[2] === "templates";

  // Your existing state
  const [isSettingsMainMenuOpen, setIsSettingsMainMenuOpen] = useState(false);
  const [isTemplateGuideOpen, setIsTemplateGuideOpen] = useState(false);
  const [isPatientGroupPopupOpen, setIsPatientGroupPopupOpen] = useState(false);
  const [isPreventiveHealthPopup1Open, setIsPreventiveHealthPopup1Open] =
    useState(false);
  const preventiveGuidelinesRef = useRef(null);

  const [isservicePopupOpen, setisservicePopupOpen] = useState(() => {
    return location1.state?.steponeclient || false;
  });

  const [openGuideFromIcon, setOpenGuideFromIcon] = useState(false);

  var accountType =
    localStorage.getItem("account_type") &&
    Decrypt_Value(localStorage.getItem("account_type"), "vozo");

  const servicesRef = useRef(null);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const Patient_subroutes = [
    "/patient/patientdashboard/",
    "/patient/demographics/",
    "/patient/appointment/",
    "/patient/billandinsurance/",
    "/patient/documents/",
    "/patient/problems/",
    "/patient/allergies/",
    "/patient/medication/",
    "/patient/immunization/",
    "/patient/familyhistory/",
    "/patient/procedureorder/",
    "/patient/senderx/",
    "/patient/clientportalaccess/",
    "/patient/flowsheet/",
  ];
  const expired_days =
    localStorage.getItem("expired_days") &&
    Decrypt_Value(localStorage.getItem("expired_days"), "vozo");
  var group_id = Decrypt_Value(localStorage.getItem("group_id"), "vozo");
  var NavData1 = useSelector((state) => state.Schedule?.NavData);
  var showAdd1 = useSelector((state) => state.Revision?.showAdd1);
  var showAdd2 = useSelector((state) => state.Revision?.showAdd2);
  var Showcontact = useSelector((state) => state.Revision?.Showcontact);
  const dispatch = useDispatch();

  const [billingMembershipNavPopup, setBillingMembershipNavPopup] =
    useState(false);

  const billingMembershipNavRef = useRef(null);
  // const [
  //   billingMembershipNavPopupPosition,
  //   setBillingMembershipNavPopupPosition,
  // ] = useState(null);

  const storedNames =
    localStorage.getItem("setroles") &&
    Decrypt_Value(localStorage.getItem("setroles"), "vozo");

  // ------------------------------ State and Variables end---------------------------------------------------//

  const popupStep = query.get("step");
  const macroRef = useRef(null);
  const orderSetRef = useRef(null);
  const batchRef = useRef(null);
  const batchNavScrollTopRef = useRef(0);
  const macroNavScrollTopRef = useRef(0);
  const batchPopupFrameRef = useRef(null);
  const appointmentWaitlistRef = useRef(null);
  const templateGuideRef = useRef(null);
  const [batchPopupPositionKey, setBatchPopupPositionKey] = useState(0);

  const refreshBatchPopupPosition = useCallback(() => {
    if (batchPopupFrameRef.current) {
      cancelAnimationFrame(batchPopupFrameRef.current);
    }

    batchPopupFrameRef.current = requestAnimationFrame(() => {
      setBatchPopupPositionKey((prev) => prev + 1);
    });
  }, []);

  // Walks up from an element to find its nearest scrollable ancestor —
  // same helper used in SettingsNav.jsx.
  const getScrollableParent = useCallback((element) => {
    let parent = element?.parentElement;

    while (parent) {
      const style = window.getComputedStyle(parent);
      const overflowY = style.overflowY;
      const canScroll =
        (overflowY === "auto" || overflowY === "scroll") &&
        parent.scrollHeight > parent.clientHeight;

      if (canScroll) {
        return parent;
      }

      parent = parent.parentElement;
    }

    return null;
  }, []);

  // --- Scroll locks for guided-tour popups (same mechanism as Batch/Macro) ---

  // Patient Engagement
  const patientEngagementScrollParentRef = useNavPopupScrollLock(
    decryptedPermission.demo && isIntroOpen,
    servicesRef,
    getScrollableParent,
  );

  // Add Patient Group
  const patientGroupScrollParentRef = useNavPopupScrollLock(
    isPatientGroupPopupOpen,
    patientGroupRef,
    getScrollableParent,
  );

  // Add Screening Guidelines
  const preventiveGuidelinesScrollParentRef = useNavPopupScrollLock(
    isPreventiveHealthPopup1Open,
    preventiveGuidelinesRef,
    getScrollableParent,
  );

  // Add Diagnosis Based Order Set
  const orderSetScrollParentRef = useNavPopupScrollLock(
    popupStep === "31",
    orderSetRef,
    getScrollableParent,
  );

  // Billing Membership Plan
  const membershipPlanScrollParentRef = useNavPopupScrollLock(
    isMembershipPopupOpen || billingMembershipNavPopup,
    membershipPlanRef,
    getScrollableParent,
  );

  const appointmentWaitlistScrollParentRef = useNavPopupScrollLock(
    popupStep === "24" || popupStep === "waitlist1",
    appointmentWaitlistRef,
    getScrollableParent,
  );

  useNavPopupScrollLock(
    isTemplateGuideOpen,
    templateGuideRef,
    getScrollableParent,
  );

  // ------------------------------ Functions----start------------------------------------------------------//
  const isOnPatientDashboard = Patient_subroutes.some((path) =>
    location.pathname.includes(path),
  );
  const [isinsclaimOpen, setIsinsclaimOpen] = useState(
    location.state ? location?.state?.insclaimopen : false,
  );

  useNavPopupScrollLock(
    decryptedPermission.ins_claims &&
      isinsclaimOpen &&
      parseInt(accountType) !== 1,
    highlightinsclaim,
    getScrollableParent,
  );

  // handleIntroNext
  const handleIntroNext = () => {
    dispatch(setGetStarted({ fromComponent: true }));
    setIsIntroOpen(false);
    setIsOpen(true);
    history.replace({
      pathname: "/patient/patientlist",
      search: "?step=6.2",
    });
  };

  const handleMouseEnter = () => {
    dispatch(GetNav("iconopen"));
    setIsOpen(true);
    setIsHovered(false);
    isOnPatientDashboard
      ? setShowPatientSubMenu(true)
      : setShowPatientSubMenu(false);
    if (
      (splitLocation[1] === "schedule" && splitLocation[2] === "nav") ||
      splitLocation[2] === "calender" ||
      (location.pathname === "/" && storedNames.appt)
    ) {
      setOpenSubMenu("schedule");
    } else {
      setOpenSubMenu(splitLocation[1]);
    }

    if (location.pathname === "/" && !storedNames.appt && storedNames.demo) {
      setOpenSubMenu("patient");
    } else if (
      location.pathname === "/" &&
      !storedNames.appt &&
      !storedNames.demo &&
      storedNames.bill
    ) {
      setOpenSubMenu("billing");
    } else if (
      location.pathname === "/" &&
      !storedNames.appt &&
      !storedNames.demo &&
      !storedNames.bill &&
      storedNames.rep
    ) {
      setOpenSubMenu("report");
    } else if (
      location.pathname === "/" &&
      !storedNames.appt &&
      !storedNames.demo &&
      !storedNames.bill &&
      !storedNames.rep &&
      storedNames.users
    ) {
      setOpenSubMenu("settings");
    }
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const handleClose = () => {
    dispatch(GetNav("iconclose"));
    isOnPatientDashboard && setShowPatientSubMenu(false);
    setIsOpen(false);
    setOpenSubMenu("");
  };

  const handleSubMenuClick = (menuName) => {
    setOpenSubMenu(openSubMenu === menuName ? "" : menuName);
  };

  const handleMouseEnterPatient = () => {
    setShowPatientSubMenu(true);
    setIsOpen(true);
    setOpenSubMenu("patient");
  };

  const exploreMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsHovered(true);
  };

  // Timeout to work the hover effect
  const exploreMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsHovered(false);
    }, 200);
  };
  const handleInputChange = (iconName) => (e) => {
    dispatch(GetNav(iconName));
  };
  const handleInputChange1 = (iconName) => {
    dispatch(GetNav(iconName));
  };
  const [shouldScrollToTop, setShouldScrollToTop] = useState(false);
  const scrollToTop = () => {
    setShouldScrollToTop(true);
    if (navRef.current) {
      navRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const scrollBillingMembershipNavToTarget = () => {
    const navElement = navRef.current;
    const targetElement = billingMembershipNavRef.current;

    if (!navElement || !targetElement) {
      return false;
    }

    const navRect = navElement.getBoundingClientRect();
    const targetRect = targetElement.getBoundingClientRect();

    const targetTop = targetRect.top - navRect.top + navElement.scrollTop;

    const nextScrollTop =
      targetTop - navElement.clientHeight / 2 + targetRect.height / 2;

    navElement.scrollTo({
      top: Math.max(nextScrollTop, 0),
      behavior: "smooth",
    });

    return true;
  };

  // const updateBillingMembershipNavPopupPosition = () => {
  //   if (!billingMembershipNavRef.current) return;

  //   const rect = billingMembershipNavRef.current.getBoundingClientRect();
  //   const popupWidth = 320;
  //   const popupHeight = 170;
  //   const gap = 16;

  //   const top = Math.max(
  //     12,
  //     Math.min(
  //       rect.top + rect.height / 2 - popupHeight / 2,
  //       window.innerHeight - popupHeight - 12,
  //     ),
  //   );

  //   const left = Math.min(
  //     rect.right + gap,
  //     window.innerWidth - popupWidth - 12,
  //   );

  //   setBillingMembershipNavPopupPosition({
  //     top,
  //     left,
  //   });
  // };
  // ------------------------------ Functions----end---------------------------------------------------//

  // ------------------------------ useEffect----start---------------------------------------------------//
  useEffect(() => {
    if (isOnPatientDashboard && isOpen) {
      handleMouseEnterPatient();
      setShowPatientSubMenu(true);
    }
  }, [isOnPatientDashboard]);
  useEffect(() => {
    if (shouldScrollToTop && navRef.current) {
      navRef.current.scrollTo({ top: 0, behavior: "smooth" });
      setShouldScrollToTop(false); // Reset after scrolling
    }
  }, [shouldScrollToTop]);
  useEffect(() => {
    UnLoadScripts();
  }, []);
  useEffect(() => {
    if (NavData1 === "iconclose") {
      setIsOpen(false);
      setOpenSubMenu("");
    } else if (NavData1 === "iconopen") {
      setIsOpen(true);
      if (
        (splitLocation[1] === "schedule" && splitLocation[2] === "nav") ||
        splitLocation[2] === "calender" ||
        location.pathname === "/"
      ) {
        setOpenSubMenu("schedule");
      } else {
        setOpenSubMenu(splitLocation[1]);
      }
    }
  }, [NavData1]);

  useEffect(() => {
    if (NavData1 === "iconclose") {
      setIsOpen(false);
      setOpenSubMenu("");
    } else if (NavData1 === "iconopen") {
      setIsOpen(true);

      if (!isTemplatesPage) {
        setOpenSubMenu(splitLocation[1]);
      } else {
        setOpenSubMenu("");
      }
    }
  }, [NavData1, splitLocation[1], splitLocation[2]]);

  useEffect(() => {
    if (splitLocation[1] === "settings" && splitLocation[2] === "templates") {
      setOpenSubMenu("");
    }
  }, [splitLocation[1], splitLocation[2]]);
  useEffect(() => {
    const updatePopupPosition = () => {
      if (isservicePopupOpen) {
        const rect = servicesRef.current.getBoundingClientRect();
        setPopupPosition({
          top: rect.y + window.scrollY - 180, // 10px below the highlighted section
          left: rect.left + window.scrollX + 90,
        });
      }
    };

    return updatePopupPosition();
  }, [isservicePopupOpen]);

  useEffect(() => {
    if (popupStep === "24" || popupStep === "waitlist1") {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));
      setOpenSubMenu("schedule");

      setTimeout(() => {
        appointmentWaitlistRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 300);
    }
  }, [popupStep]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const step = query.get("step");

    if (step === "6.1") {
      setIsIntroOpen(false); // 🔒 Close popup first

      setTimeout(() => {
        navRef.current?.scrollTo({
          top: 0,
          behavior: "smooth",
        });

        // ✅ Open popup after scrolling
        const openPopupDelay = setTimeout(() => {
          setIsIntroOpen(true);

          setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
          }, 100);
        }, 500); // ⏳ Wait for smooth scroll animation to complete

        // Cleanup nested timeout
        return () => clearTimeout(openPopupDelay);
      }, 200);

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    } else if (step === "6.4") {
      setOpenSubMenu("schedule");
      setShowStepFourIntro(true);
      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    }
  }, [location?.search]);

  useEffect(() => {
    if (location?.state?.patientportalstarted && navRef.current) {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));
      setIsHovered(false);
      setOpenSubMenu("settings");
      window.scrollTo(0, 0);
      setTimeout(() => {
        navRef.current.scrollTo({
          top: 300,
          behavior: "smooth",
        });
      }, 0);
    }
  }, [location?.state?.patientportalstarted]);
  useEffect(() => {
    if (location?.state?.payerstateopen && navRef.current) {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));
      setOpenSubMenu("settings");

      setTimeout(() => {
        navRef.current.scrollTo({
          top: navRef.current.scrollHeight,
          behavior: "smooth",
        });
      }, 500);
    }
  }, [location?.state?.payerstateopen]);

  useEffect(() => {
    if (popupStep === "29.1" || popupStep === "31" || popupStep === "28.1") {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));
      setOpenSubMenu("patient");
      setTimeout(() => {
        const activeRef =
          popupStep === "29.1"
            ? macroRef
            : popupStep === "31"
              ? orderSetRef
              : batchRef;
        if (activeRef.current) {
          activeRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
          }, 500);
        }
      }, 500);
    }
  }, [popupStep, dispatch]);

  useEffect(() => {
    return () => {
      if (batchPopupFrameRef.current) {
        cancelAnimationFrame(batchPopupFrameRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (popupStep !== "28.1") return;

    const handlePositionUpdate = () => {
      refreshBatchPopupPosition();
    };

    const timer = setTimeout(() => {
      if (batchRef.current) {
        batchRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      handlePositionUpdate();
    }, 900);

    window.addEventListener("resize", handlePositionUpdate);
    window.addEventListener("scroll", handlePositionUpdate, true);

    const navElement = navRef.current;
    if (navElement) {
      navElement.addEventListener("scroll", handlePositionUpdate);
    }

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handlePositionUpdate);
      window.removeEventListener("scroll", handlePositionUpdate, true);

      if (navElement) {
        navElement.removeEventListener("scroll", handlePositionUpdate);
      }
    };
  }, [popupStep, refreshBatchPopupPosition]);

  useEffect(() => {
    if (popupStep !== "28.1" || !navRef.current) return;

    let cleanupScrollLock = null;

    const timer = setTimeout(() => {
      const scrollParent = navRef.current;

      if (!scrollParent) return;

      batchNavScrollTopRef.current = scrollParent.scrollTop;

      const previousOverflowY = scrollParent.style.overflowY;
      const previousOverscrollBehavior = scrollParent.style.overscrollBehavior;

      scrollParent.style.overflowY = "hidden";
      scrollParent.style.overscrollBehavior = "contain";

      const lockScroll = (e) => {
        const isZoomGesture =
          e.ctrlKey || e.metaKey || (e.touches && e.touches.length > 1);

        if (isZoomGesture) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        if (navRef.current) {
          navRef.current.scrollTop = batchNavScrollTopRef.current;
        }
      };

      const keepScrollFixed = () => {
        if (navRef.current) {
          navRef.current.scrollTop = batchNavScrollTopRef.current;
        }
      };

      scrollParent.addEventListener("wheel", lockScroll, {
        passive: false,
        capture: true,
      });

      scrollParent.addEventListener("touchmove", lockScroll, {
        passive: false,
        capture: true,
      });

      scrollParent.addEventListener("scroll", keepScrollFixed, true);

      cleanupScrollLock = () => {
        scrollParent.removeEventListener("wheel", lockScroll, true);
        scrollParent.removeEventListener("touchmove", lockScroll, true);
        scrollParent.removeEventListener("scroll", keepScrollFixed, true);

        scrollParent.style.overflowY = previousOverflowY;
        scrollParent.style.overscrollBehavior = previousOverscrollBehavior;
      };
    }, 950);

    return () => {
      clearTimeout(timer);

      if (cleanupScrollLock) {
        cleanupScrollLock();
      }
    };
  }, [popupStep]);

  useEffect(() => {
    if (popupStep !== "29.1" || !navRef.current) return;

    let cleanupScrollLock = null;

    const timer = setTimeout(() => {
      const scrollParent = navRef.current;

      if (!scrollParent) return;

      macroNavScrollTopRef.current = scrollParent.scrollTop;

      const previousOverflowY = scrollParent.style.overflowY;
      const previousOverscrollBehavior = scrollParent.style.overscrollBehavior;

      scrollParent.style.overflowY = "hidden";
      scrollParent.style.overscrollBehavior = "contain";

      const lockScroll = (e) => {
        const isZoomGesture =
          e.ctrlKey || e.metaKey || (e.touches && e.touches.length > 1);

        if (isZoomGesture) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        if (navRef.current) {
          navRef.current.scrollTop = macroNavScrollTopRef.current;
        }
      };

      const keepScrollFixed = () => {
        if (navRef.current) {
          navRef.current.scrollTop = macroNavScrollTopRef.current;
        }
      };

      scrollParent.addEventListener("wheel", lockScroll, {
        passive: false,
        capture: true,
      });

      scrollParent.addEventListener("touchmove", lockScroll, {
        passive: false,
        capture: true,
      });

      scrollParent.addEventListener("scroll", keepScrollFixed, true);

      cleanupScrollLock = () => {
        scrollParent.removeEventListener("wheel", lockScroll, true);
        scrollParent.removeEventListener("touchmove", lockScroll, true);
        scrollParent.removeEventListener("scroll", keepScrollFixed, true);

        scrollParent.style.overflowY = previousOverflowY;
        scrollParent.style.overscrollBehavior = previousOverscrollBehavior;
      };
    }, 950);

    return () => {
      clearTimeout(timer);

      if (cleanupScrollLock) {
        cleanupScrollLock();
      }
    };
  }, [popupStep]);

  useEffect(() => {
    if (location?.state?.patientpaymentopen && navRef.current) {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));
      setIsHovered(false);
      setOpenSubMenu("billing");
    }
  }, [location?.state?.patientpaymentopen]);
  // useEffect(() => {
  //   if (location?.state?.insclaimopen && navRef.current) {
  //     setIsOpen(true);
  //     dispatch(GetNav("iconopen"));
  //     setIsHovered(false);
  //     setOpenSubMenu("billing");
  //   }
  // }, [location?.state?.insclaimopen]);

  useEffect(() => {
    if (location?.state?.membershipplanstarted && navRef.current) {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));
      setIsHovered(false);
      setOpenSubMenu("patient");

      // Wait for submenu to render, then scroll to the Membership Plan item
      setTimeout(() => {
        if (membershipPlanRef.current) {
          membershipPlanRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        // Wait for scroll animation to complete before showing popup & overlay
        const showPopupDelay = setTimeout(() => {
          setIsMembershipPopupOpen(true);
        }, 500);
        return () => clearTimeout(showPopupDelay);
      }, 300);
    }
  }, [location?.state?.membershipplanstarted]);

  useEffect(() => {
    if (location?.state?.patientgroupstarted) {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));
      setIsHovered(false);
      setOpenSubMenu("patient");

      setTimeout(() => {
        if (patientGroupRef.current) {
          patientGroupRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        const showPopupDelay = setTimeout(() => {
          setIsPatientGroupPopupOpen(true);
        }, 500);
        return () => clearTimeout(showPopupDelay);
      }, 300);
    }
  }, [location?.state?.patientgroupstarted]);

  useEffect(() => {
    if (location?.state?.preventivehealthstarted1 && navRef.current) {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));
      setIsHovered(false);
      setOpenSubMenu("patient");

      setTimeout(() => {
        if (preventiveGuidelinesRef.current) {
          preventiveGuidelinesRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        const showPopupDelay = setTimeout(() => {
          setIsPreventiveHealthPopup1Open(true);
        }, 500);
        return () => clearTimeout(showPopupDelay);
      }, 300);
    }
  }, [location?.state?.preventivehealthstarted1]);

  // useEffect(() => {
  //   if (location?.data && location.data?.serbillgetstart1 && navRef.current) {
  //     setisservicePopupOpen(true);
  //     window.scrollTo(0, 0);
  //     setTimeout(() => {
  //       navRef.current.scrollTo({
  //         top: 300,
  //         behavior: "smooth",
  //       });
  //     }, 0);
  //   }
  // }, [location?.data?.serbillgetstart1]);
  // useEffect(() => {
  //   const query = new URLSearchParams(location.search);
  //   const step = query.get("step");

  //   if (step === "1.2") {
  //     setIsSettingsMainMenuOpen(true); // or whatever you want to trigger

  //     query.delete("step");
  //     history.replace({
  //       pathname: location.pathname,
  //       search: query.toString(),
  //     });
  //   } else if (step === "23.1" && location.pathname.includes("/patient/membershipplan")) {
  //     setIsOpen(true);
  //     dispatch(GetNav("iconopen"));
  //     setIsHovered(false);
  //     setOpenSubMenu("patient");

  //     setTimeout(() => {
  //       if (membershipPlanRef.current) {
  //         membershipPlanRef.current.scrollIntoView({
  //           behavior: "smooth",
  //           block: "center",
  //         });
  //       }
  //       const showPopupDelay = setTimeout(() => {
  //         setIsMembershipPopupOpen(true);
  //       }, 500);
  //       return () => clearTimeout(showPopupDelay);
  //     }, 300);

  //     query.delete("step");
  //     history.replace({
  //       pathname: location.pathname,
  //       search: query.toString(),
  //     });
  //   }
  // }, [location.search]);
  useEffect(() => {
    if (isSettingsMainMenuOpen && navItemRef.current) {
      navItemRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [isSettingsMainMenuOpen]);

  useEffect(() => {
    const handleOpen1Step = () => {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));

      setTimeout(() => {
        templateGuideRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        setIsTemplateGuideOpen(true);

        setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
        }, 100);
      }, 300);
    };

    window.addEventListener("open1stepPopup", handleOpen1Step);

    if (location?.state?.showTemplatePopup) {
      handleOpen1Step();
    }

    return () => {
      window.removeEventListener("open1stepPopup", handleOpen1Step);
    };
  }, [location?.state?.showTemplatePopup]);

  useEffect(() => {
    if (location?.state?.insclaimopen !== undefined) {
      if (location?.state?.insclaimopen === true) {
        setIsinsclaimOpen(true);
      } else {
        setIsinsclaimOpen(false);
      }
    }
  }, [location?.state?.insclaimopen]);

  useEffect(() => {
    if (location?.state?.insclaimopenfromaccount !== undefined) {
      if (location?.state?.insclaimopenfromaccount === true) {
        setIsinsclaimOpen(true);
      } else {
        setIsinsclaimOpen(false);
      }
    }
  }, [location?.state?.insclaimopenfromaccount]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const step = query.get("step");

    if (
      !(
        location.pathname.includes("patientdashboard") ||
        location.pathname.includes("appointment")
      )
    ) {
      if (step !== "19" && step !== "20" && step !== "21" && step !== "22") {
        dispatch(GetNav("iconopen"));
      } else {
        dispatch(GetNav("iconclose"));
      }
    } else {
      dispatch(GetNav("iconclose")); // force close when in these paths
    }

    if (step === "6.1") {
      setIsIntroOpen(true);

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    } else if (step === "6.4") {
      setOpenSubMenu("schedule");
      setShowStepFourIntro(true);
      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    }
  }, []);

  // useEffect(() => {
  //   const query = new URLSearchParams(location.search);
  //   const step = query.get("step");

  //   if (step === "billing-membership.1") {
  //     dispatch(GetNav("iconopen"));
  //     setIsOpen(true);
  //     setShowPatientSubMenu(false);
  //     setOpenSubMenu("patient");
  //     setBillingMembershipNavPopup(false);
  //     setBillingMembershipNavPopupPosition(null);

  //     setTimeout(() => {
  //       setOpenSubMenu("patient");

  //       setTimeout(() => {
  //         const didScroll = scrollBillingMembershipNavToTarget();

  //         if (!didScroll && navRef.current) {
  //           navRef.current.scrollTo({
  //             top: 520,
  //             behavior: "smooth",
  //           });
  //         }

  //         setTimeout(() => {
  //           updateBillingMembershipNavPopupPosition();
  //           setBillingMembershipNavPopup(true);
  //         }, 700);
  //       }, 250);
  //     }, 250);

  //     query.delete("step");

  //     history.replace({
  //       pathname: location.pathname,
  //       search: query.toString(),
  //       state: location.state,
  //     });
  //   }
  // }, [location.search]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const step = query.get("step");

    if (step === "1.2") {
      setIsSettingsMainMenuOpen(true);

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });

      return;
    }

    if (
      step === "23.1" &&
      location.pathname.includes("/patient/membershipplan")
    ) {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));
      setIsHovered(false);
      setOpenSubMenu("patient");
      setBillingMembershipNavPopup(false);

      setTimeout(() => {
        if (membershipPlanRef.current) {
          membershipPlanRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }

        setTimeout(() => {
          setIsMembershipPopupOpen(true);
        }, 500);
      }, 300);

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });

      return;
    }
  }, [location.search]);

  useEffect(() => {
    if (isIntroOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isIntroOpen]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const step = query.get("step");

    if (step === "billing-membership.1") {
      dispatch(GetNav("iconopen"));
      setIsOpen(true);
      setShowPatientSubMenu(false);
      setOpenSubMenu("patient");
      setIsMembershipPopupOpen(false);
      setBillingMembershipNavPopup(false);

      setTimeout(() => {
        setOpenSubMenu("patient");

        setTimeout(() => {
          const didScroll = scrollBillingMembershipNavToTarget();

          if (!didScroll && navRef.current) {
            navRef.current.scrollTo({
              top: 520,
              behavior: "smooth",
            });
          }

          setTimeout(() => {
            setBillingMembershipNavPopup(true);
          }, 700);
        }, 250);
      }, 250);

      query.delete("step");

      history.replace({
        pathname: location.pathname,
        search: query.toString(),
        state: location.state,
      });
    }
  }, [location.search]);
  useEffect(() => {
    if (isTemplateGuideOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isTemplateGuideOpen]);
  // useEffect(() => {
  //   if (!billingMembershipNavPopup) return;

  //   const handleReposition = () => {
  //     updateBillingMembershipNavPopupPosition();
  //   };

  //   window.addEventListener("resize", handleReposition);
  //   window.addEventListener("scroll", handleReposition, true);

  //   const navElement = navRef.current;
  //   if (navElement) {
  //     navElement.addEventListener("scroll", handleReposition);
  //   }

  //   setTimeout(handleReposition, 0);

  //   return () => {
  //     window.removeEventListener("resize", handleReposition);
  //     window.removeEventListener("scroll", handleReposition, true);

  //     if (navElement) {
  //       navElement.removeEventListener("scroll", handleReposition);
  //     }
  //   };
  // }, [billingMembershipNavPopup]);

  // ------------------------------ useEffect----end---------------------------------------------------//

  return (
    <>
      <Nav
        className={expired_days < 0 ? "sidenav-disabled" : ""}
        ref={navRef}
        onMouseLeave={handleMouseLeave}
        isopen={isOpen ? "true" : "false"}
        isOnPatientDashboard={isOnPatientDashboard}
        zindex={
          popupStep === "29.1" || popupStep === "31" || popupStep === "28.1"
            ? "10000"
            : (isOnPatientDashboard && showPatientSubMenu) || isHovered
              ? "1040"
              : Showcontact || showAdd1 || showAdd2
                ? "0"
                : "11"
        }
      >
        {(popupStep === "29.1" ||
          popupStep === "31" ||
          popupStep === "28.1") && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              zIndex: 9998,
              pointerEvents: "none",
            }}
          />
        )}
        <TopIcon>
          {isOpen ? (
            <img
              src={Greaterthanopp}
              alt="Close-icon"
              onClick={handleClose}
              style={{ marginLeft: "135px" }}
            ></img>
          ) : (
            <img
              src={Greaterthan}
              alt="menu-icon"
              onClick={handleMouseEnter}
              style={{ width: "24px" }}
            ></img>
          )}
        </TopIcon>
        <Div display="flex" width="100%" marginLeft={isOpen ? "40px" : "0px"}>
          <NavItem
            isopen={isOpen ? "true" : "false"}
            to="/dashboard"
            color={pathname === "/dashboard" ? globalColor : "#2E2E2E80"}
            onClick={() => {
              handleInputChange1("iconclose");
              setIsOpen(false);
            }}
          >
            {isOpen ? (
              <>
                <MdOutlineDashboard size={22} />
                <Span>Dashboard</Span>
              </>
            ) : (
              <>
                <MdOutlineDashboard size={22} className="svgSize1" />
                <div style={{ fontSize: "12px" }}>Dashboard</div>
              </>
            )}
          </NavItem>
        </Div>
        <Div display="flex" width="100%" marginLeft={isOpen ? "40px" : "0px"}>
          <NavItem
            isopen={isOpen ? "true" : "false"}
            to="/schedule/nav/1"
            color={
              splitLocation[1] === "schedule" || location.pathname === "/"
                ? globalColor
                : "#2E2E2E80"
            }
            onClick={(e) => {
              if (isOpen) {
                e.preventDefault();
                handleSubMenuClick("schedule");
              }
              handleInputChange1("iconopen");
            }}
          >
            {isOpen ? (
              <>
                <BsCalendar4 strokeWidth="0.5" />
                <Span>Schedule</Span>
              </>
            ) : (
              <>
                <BsCalendar4 strokeWidth="0.5" className="svgSize1" />
                <div style={{ fontSize: "12px" }}>Schedule</div>
              </>
            )}
          </NavItem>
          {isOpen && (
            <Div
              onClick={() => handleSubMenuClick("schedule")}
              cursor="pointer"
              margin="24px 20px 0 20px"
              alignItems="center"
              display="flex"
              color={
                splitLocation[1] === "schedule" ||
                (location.pathname === "/" && storedNames.appt)
                  ? globalColor
                  : "#2E2E2E80"
              }
            >
              {openSubMenu === "schedule" ? (
                <FiChevronDown className="svgSize" />
              ) : (
                <FiChevronRight className="svgSize" />
              )}
            </Div>
          )}
        </Div>
        {openSubMenu === "schedule" && (
          <ScheduleNav
            showStepFourIntro={showStepFourIntro}
            setShowStepFourIntro={setShowStepFourIntro}
            appointmentWaitlistRef={appointmentWaitlistRef}
          />
        )}
        <Div display="flex" width="100%" marginLeft={isOpen ? "40px" : "0px"}>
          <NavItem
            isopen={isOpen ? "true" : "false"}
            to="/patient/nav/1"
            id="pt_nav-lnk_mnu"
            onClick={(e) => {
              if (isOpen) {
                e.preventDefault();
                handleSubMenuClick("patient");
              }
              handleInputChange1("iconopen");
            }}
            color={
              splitLocation[1] === "patient" ||
              (location.pathname === "/" &&
                !storedNames.appt &&
                storedNames.demo)
                ? globalColor
                : "#2E2E2E80"
            }
          >
            {isOpen ? (
              <>
                <FaUsers strokeWidth="0.5" />
                <Span>Patient</Span>
              </>
            ) : (
              <>
                <FaUsers strokeWidth="0.5" />
                <div style={{ fontSize: "12px" }}>Patient</div>
              </>
            )}
          </NavItem>
          {isOpen && (
            <Div
              onClick={() => handleSubMenuClick("patient")}
              cursor="pointer"
              margin="24px 20px 0 20px"
              alignItems="center"
              display="flex"
              color={
                splitLocation[1] === "patient" ||
                (location.pathname === "/" &&
                  !storedNames.appt &&
                  storedNames.demo)
                  ? globalColor
                  : "#2E2E2E80"
              }
            >
              {openSubMenu === "patient" ? (
                <FiChevronDown className="svgSize" />
              ) : (
                <FiChevronRight className="svgSize" />
              )}
            </Div>
          )}
        </Div>
        {decryptedPermission.demo && isIntroOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 9999,
            }}
            onClick={() => setIsIntroOpen(false)}
          />
        )}
        {isPatientGroupPopupOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 9999,
            }}
            onClick={() => {
              setIsPatientGroupPopupOpen(false);
              history.replace({
                pathname: location.pathname,
                state: {},
              });
            }}
          />
        )}
        {isPreventiveHealthPopup1Open && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 9999,
            }}
            onClick={() => {
              setIsPreventiveHealthPopup1Open(false);
              history.replace({
                pathname: location.pathname,
                state: {},
              });
            }}
          />
        )}
        {openSubMenu === "patient" && (
          <Div display="flex" width="100%" paddingLeft="0.86em">
            <UL
              position="relative"
              padding="0 0 16px 0"
              listStyleType="none"
              width="100%"
              textAlign="center"
              margin="0"
            >
              <ListItem
                ref={servicesRef}
                padding="8px"
                margin="8px 0 0 0"
                onClick={handleInputChange("iconclose")}
                position="relative"
              >
                <Popup
                  offset={[40, 10]}
                  content={
                    <GetStartedPopup
                      title="Patient Engagement"
                      description={
                        <div>
                          Go to Patient {">"} Patient list menu to create &
                          access all of your patient details from the patients
                          list.
                        </div>
                      }
                      currentStep={1}
                      totalSteps={6}
                      onNext={handleIntroNext}
                      onClose={() => setIsIntroOpen(false)}
                      width="320px"
                    />
                  }
                  open={decryptedPermission.demo && isIntroOpen}
                  className="m-t-10"
                  trigger={
                    <SubNavItem
                      to="/patient/patientlist"
                      exact
                      className={`${
                        (splitLocation[1] === "patient" &&
                          splitLocation[2] === "nav") ||
                        splitLocation[2] === "patientlist"
                          ? "active"
                          : ""
                      } ${
                        decryptedPermission.demo && isIntroOpen
                          ? "highlight"
                          : ""
                      }`}
                      style={
                        decryptedPermission.demo && isIntroOpen
                          ? { padding: "4px 10px" }
                          : {}
                      }
                    >
                      Patients
                    </SubNavItem>
                  }
                  position="left center"
                />
              </ListItem>
              <Popup
                style={{ zIndex: 10001 }}
                offset={[40, 20]}
                content={
                  <GetStartedPopup
                    title="Add Patient Group"
                    description={
                      <div>
                        Go to Patient {">"} Patient Group menu to create and
                        assign patients in a Patient Group
                      </div>
                    }
                    currentStep={1}
                    totalSteps={7}
                    onNext={() => {
                      setIsPatientGroupPopupOpen(false);
                      history.replace({
                        pathname: "/patient/PatientGroup",
                        state: { patientgroupstarted2: true },
                      });
                    }}
                    onClose={() => {
                      setIsPatientGroupPopupOpen(false);
                      history.replace({
                        pathname: location.pathname,
                        state: {},
                      });
                    }}
                    width="320px"
                  />
                }
                open={isPatientGroupPopupOpen}
                position="right center"
                trigger={
                  <ListItem
                    ref={patientGroupRef}
                    padding="8px"
                    margin="0"
                    onClick={handleInputChange("iconopen")}
                    style={
                      isPatientGroupPopupOpen
                        ? {
                            ...getHighlightStyles(true),
                            color: "#2C7BE5",
                          }
                        : {}
                    }
                  >
                    <SubNavItem
                      to="/patient/PatientGroup"
                      exact
                      style={
                        isPatientGroupPopupOpen
                          ? {
                              color: "#2C7BE5",
                              fontWeight: 600,
                            }
                          : {}
                      }
                    >
                      Patient Group
                    </SubNavItem>
                  </ListItem>
                }
              />
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/notetaking" exact>
                  Note Taking
                </SubNavItem>
              </ListItem>
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/patientflag" exact>
                  Patient Flag
                </SubNavItem>
              </ListItem>
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconclose")}
              >
                <SubNavItem to="/patient/electronicreports" exact>
                  Lab Reports
                </SubNavItem>
              </ListItem>
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconclose")}
                ref={preventiveGuidelinesRef}
                position="relative"
              >
                <Popup
                  offset={[40, 15]}
                  content={
                    <GetStartedPopup
                      title="Add Screening Guidelines"
                      description="Go to Patient > Preventive Guidelines menu to add guidelines for Health screening and assess risks."
                      currentStep={1}
                      totalSteps={11}
                      onNext={() => {
                        setIsPreventiveHealthPopup1Open(false);
                        history.replace({
                          pathname: location.pathname,
                          state: { preventivehealthstarted2: true },
                        });
                      }}
                      onClose={() => {
                        setIsPreventiveHealthPopup1Open(false);
                        history.replace({
                          pathname: location.pathname,
                          state: {},
                        });
                      }}
                      width="320px"
                    />
                  }
                  open={isPreventiveHealthPopup1Open}
                  position="right center"
                  style={{ zIndex: 10001 }}
                  trigger={
                    <SubNavItem
                      to="/patient/preventiveguidelines"
                      exact
                      className={
                        isPreventiveHealthPopup1Open ? "highlight" : ""
                      }
                      style={
                        isPreventiveHealthPopup1Open
                          ? {
                              zIndex: 10001,
                              position: "relative",
                              backgroundColor: "#fff",
                              padding: "8px",
                            }
                          : {}
                      }
                    >
                      Preventive Guidelines
                    </SubNavItem>
                  }
                />
              </ListItem>
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/referralmanageMent" exact>
                  Referral ManageMent
                </SubNavItem>
              </ListItem>
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/patienteducation" exact>
                  Patient Education
                </SubNavItem>
              </ListItem>

              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/DietRecommendation" exact>
                  Diet Recommendation
                </SubNavItem>
              </ListItem>
              <Popup
                trigger={
                  <ListItem
                    padding="8px"
                    margin="0"
                    onClick={handleInputChange("iconopen")}
                    ref={popupStep === "31" ? orderSetRef : null}
                    style={{
                      ...(popupStep === "31" ? getHighlightStyles(true) : {}),
                    }}
                  >
                    <SubNavItem
                      to="/patient/Orderset"
                      isActive={(match, location) =>
                        location.pathname.includes("/patient/Orderset")
                      }
                      style={{
                        display: "block",
                        width: "100%",
                        ...(popupStep === "31"
                          ? getItemHighlightStyles(true)
                          : {}),
                      }}
                    >
                      Order Set
                    </SubNavItem>
                  </ListItem>
                }
                open={popupStep === "31"}
                position="right center"
                className="no-sui-arrow"
                style={{
                  zIndex: 10003,
                  width: "300px",
                  opacity: 1,
                }}
                offset={[45, 10]}
                popperModifiers={[
                  { name: "flip", enabled: false },
                  { name: "preventOverflow", enabled: true },
                ]}
                on={[]}
                content={
                  popupStep === "31" ? (
                    <GetStartedPopup
                      title="Add Diagnosis Based Order Set"
                      description="Go to Patient > Order Set menu to create Order Set based on the patients diagnosis"
                      currentStep={1}
                      totalSteps={8}
                      arrowPosition="left-top"
                      onNext={() => {
                        handleInputChange1("iconclose");
                        setIsOpen(false);
                        history.replace({
                          pathname: "/patient/Orderset",
                          search: "?step=31.2",
                        });
                      }}
                      onClose={() => {
                        history.replace({
                          pathname: location.pathname,
                          search: "",
                        });
                      }}
                      closeOnOutsideClick={true}
                      showBackdrop={true}
                      topClose={true}
                      width="300px"
                    />
                  ) : null
                }
              />
              {/* <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem
                  to="/patient/Orderset"
                  isActive={(match, location) =>
                    location.pathname.includes("/patient/Orderset")
                  }
                >
                  Order Set
                </SubNavItem>
              </ListItem> */}
              {/* <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/membershipplan" exact>
                  Membership Plan
                </SubNavItem>
              </ListItem> */}
              {/* <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem
                  to="/patient/membershipplan"
                  exact
                  onClick={(e) => {
                    if (billingMembershipNavPopup) {
                      e.preventDefault();
                    }
                  }}
                >
                  <span
                    ref={billingMembershipNavRef}
                    className={
                      billingMembershipNavPopup
                        ? "membership-billing-tour-text-highlight"
                        : ""
                    }
                  >
                    Membership Plan
                  </span>
                </SubNavItem>
              </ListItem> */}
              <ListItem
                ref={membershipPlanRef}
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
                style={
                  isMembershipPopupOpen
                    ? {
                        ...getHighlightStyles(true),
                        color: "#2C7BE5",
                      }
                    : {}
                }
              >
                <Popup
                  open={isMembershipPopupOpen || billingMembershipNavPopup}
                  position="right center"
                  offset={[40, 20]}
                  className="m-t-10"
                  style={{ zIndex: 10001 }}
                  content={
                    <GetStartedPopup
                      title="Billing Membership Plan"
                      description={
                        billingMembershipNavPopup ? (
                          "Go to Patient > Membership plan menu to create & assign the membership plan to the patient within the patient demographics."
                        ) : (
                          <div>
                            Go to Patient {">"} Membership plan menu to create &
                            assign the membership plan to the patient within the
                            patient demographics
                          </div>
                        )
                      }
                      currentStep={1}
                      totalSteps={8}
                      onNext={() => {
                        if (billingMembershipNavPopup) {
                          setBillingMembershipNavPopup(false);

                          history.replace({
                            pathname: "/patient/membershipplan",
                            search: "?step=billing-membership.2",
                          });

                          return;
                        }

                        setIsMembershipPopupOpen(false);

                        history.push({
                          pathname: "/patient/membershipplan",
                          search: "?step=23.2",
                        });
                      }}
                      onClose={() => {
                        setIsMembershipPopupOpen(false);
                        setBillingMembershipNavPopup(false);
                      }}
                      width="320px"
                    />
                  }
                  trigger={
                    <SubNavItem
                      to="/patient/membershipplan"
                      exact
                      onClick={(e) => {
                        if (
                          isMembershipPopupOpen ||
                          billingMembershipNavPopup
                        ) {
                          e.preventDefault();
                        }
                      }}
                      style={
                        isMembershipPopupOpen
                          ? {
                              color: "#2C7BE5",
                              fontWeight: 600,
                            }
                          : {}
                      }
                    >
                      <span
                        ref={billingMembershipNavRef}
                        className={
                          billingMembershipNavPopup
                            ? "membership-billing-tour-text-highlight"
                            : ""
                        }
                      >
                        Membership Plan
                      </span>
                    </SubNavItem>
                  }
                />
              </ListItem>

              {/* <Popup
                trigger={
                  <ListItem
                    padding="8px"
                    margin="0"
                    onClick={handleInputChange("iconopen")}
                    ref={popupStep === "28.1" ? batchRef : null}
                    style={{
                      ...(popupStep === "28.1" ? getHighlightStyles(true) : {}),
                    }}
                  >
                    <SubNavItem
                      to="/patient/BatchEligibility"
                      exact
                      style={{
                        display: "block",
                        width: "100%",
                        ...(popupStep === "28.1"
                          ? getItemHighlightStyles(true)
                          : {}),
                      }}
                    >
                      Batch Eligibility
                    </SubNavItem>
                  </ListItem>
                }
                open={popupStep === "28.1"}
                position="right center"
                className="no-sui-arrow"
                style={{ zIndex: 99999, minWidth: "300px", maxWidth: "340px" }}
                offset={[48, 10]}
                popperModifiers={[
                  { name: "flip", enabled: false },
                  { name: "preventOverflow", enabled: true },
                ]}
                on={[]}
                content={
                  popupStep === "28.1" ? (
                    <GetStartedPopup
                      title="Check Batch Coverage Details"
                      description="Go to Patient > Batch Eligibility menu to check eligibility verification details of the patients."
                      currentStep={1}
                      totalSteps={7}
                      arrowPosition="left-top"
                      onNext={() => {
                        handleInputChange1("iconclose");
                        setIsOpen(false);
                        history.replace({
                          pathname: "/patient/BatchEligibility",
                          search: "?step=28.2",
                        });
                      }}
                      onClose={() => {
                        history.replace({
                          pathname: location.pathname,
                          search: "",
                        });
                      }}
                      closeOnOutsideClick={true}
                      showBackdrop={true}
                      topClose={true}
                    />
                  ) : null
                }
              /> */}

              <Popup
                key={`batch-eligibility-nav-popup-${batchPopupPositionKey}`}
                trigger={
                  <ListItem
                    padding="8px"
                    margin="0"
                    onClick={handleInputChange("iconopen")}
                    ref={popupStep === "28.1" ? batchRef : null}
                    style={{
                      position: "relative",
                      ...(popupStep === "28.1"
                        ? {
                            ...getHighlightStyles(true),
                            zIndex: 10001,
                            backgroundColor: "#ffffff",
                            borderRadius: "4px",
                          }
                        : {}),
                    }}
                  >
                    <SubNavItem
                      to="/patient/BatchEligibility"
                      exact
                      style={{
                        display: "block",
                        width: "100%",
                        position: "relative",
                        ...(popupStep === "28.1"
                          ? {
                              ...getItemHighlightStyles(true),
                              zIndex: 10002,
                              color: "#2C7BE5",
                              fontWeight: 600,
                            }
                          : {}),
                      }}
                    >
                      Batch Eligibility
                    </SubNavItem>
                  </ListItem>
                }
                open={popupStep === "28.1"}
                position="right center"
                className="centerarrowpopup no-sui-arrow m-t-10"
                style={{
                  zIndex: 10002,
                  minWidth: "300px",
                  maxWidth: "340px",
                }}
                offset={[45, 10]}
                popperDependencies={[
                  popupStep,
                  isOpen,
                  openSubMenu,
                  batchPopupPositionKey,
                ]}
                popperModifiers={[
                  {
                    name: "eventListeners",
                    enabled: true,
                    options: { scroll: true, resize: true },
                  },
                  { name: "flip", enabled: false },
                  {
                    name: "preventOverflow",
                    enabled: true,
                    options: {
                      boundary: "viewport",
                      padding: 8,
                    },
                  },
                  {
                    name: "computeStyles",
                    enabled: true,
                    options: {
                      adaptive: false,
                    },
                  },
                ]}
                mountNode={document.getElementById("root") || document.body}
                on={[]}
                content={
                  popupStep === "28.1" ? (
                    <GetStartedPopup
                      title="Check Batch Coverage Details"
                      description="Go to Patient > Batch Eligibility menu to check eligibility verification details of the patients."
                      currentStep={1}
                      totalSteps={7}
                      arrowPosition="left-top"
                      onNext={() => {
                        handleInputChange1("iconclose");
                        setIsOpen(false);
                        history.replace({
                          pathname: "/patient/BatchEligibility",
                          search: "?step=28.2",
                        });
                      }}
                      onClose={() => {
                        history.replace({
                          pathname: location.pathname,
                          search: "",
                        });
                      }}
                      closeOnOutsideClick={true}
                      showBackdrop={true}
                      topClose={true}
                    />
                  ) : null
                }
              />

              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/IncomingFax" exact>
                  Incoming Fax
                </SubNavItem>
              </ListItem>
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/Outgoingfax" exact>
                  Outgoing Fax
                </SubNavItem>
              </ListItem>

              <Popup
                trigger={
                  <ListItem
                    padding="8px"
                    margin="0"
                    onClick={handleInputChange("iconopen")}
                    ref={popupStep === "29.1" ? macroRef : null}
                    style={{
                      position: "relative",
                      ...(popupStep === "29.1"
                        ? {
                            ...getHighlightStyles(true),
                            zIndex: 10001,
                            backgroundColor: "#ffffff",
                            borderRadius: "4px",
                          }
                        : {}),
                    }}
                  >
                    <SubNavItem
                      to="/patient/managemacrobutton"
                      exact
                      style={{
                        display: "block",
                        width: "100%",
                        position: "relative",
                        ...(popupStep === "29.1"
                          ? {
                              ...getItemHighlightStyles(true),
                              zIndex: 10002,
                              color: "#2C7BE5",
                              fontWeight: 600,
                            }
                          : {}),
                      }}
                    >
                      Macro Buttons
                    </SubNavItem>
                  </ListItem>
                }
                open={popupStep === "29.1"}
                position="right center"
                className="centerarrowpopup no-sui-arrow m-t-10"
                style={{ zIndex: 10003, minWidth: "300px", maxWidth: "340px" }}
                offset={[45, 10]}
                popperModifiers={[
                  { name: "flip", enabled: false },
                  { name: "preventOverflow", enabled: true },
                ]}
                on={[]}
                content={
                  popupStep === "29.1" ? (
                    <GetStartedPopup
                      title="Macro Button Setup"
                      description="Go to Patient > Macro button menu to setup the macro button which can be used in the patients note"
                      currentStep={1}
                      totalSteps={10}
                      arrowPosition="left-top"
                      onNext={() => {
                        handleInputChange1("iconclose");
                        setIsOpen(false);
                        history.replace({
                          pathname: "/patient/managemacrobutton",
                          search: "?step=29.2",
                        });
                      }}
                      onClose={() => {
                        history.replace({
                          pathname: location.pathname,
                          search: "",
                        });
                      }}
                      closeOnOutsideClick={true}
                      showBackdrop={false}
                      topClose={true}
                    />
                  ) : null
                }
              />
            </UL>
          </Div>
        )}
        {/* <Div display="flex" width="100%" marginLeft={isOpen ? "40px" : "0px"}>
          <NavItem
            isopen={isOpen ? "true" : "false"}
            to="/settings/templates"
            color={
              pathname.includes("/settings/templates")
                ? globalColor
                : "#2E2E2E80"
            }
            onClick={() => {
              handleInputChange1("iconclose");

              setOpenSubMenu("");
              setIsOpen(false);
            }}
          >
            {isOpen ? (
              <>
                <MdOutlineViewQuilt size={22} />
                <Span>Templates</Span>
              </>
            ) : (
              <>
                <MdOutlineViewQuilt size={22} className="svgSize1" />
                <div style={{ fontSize: "12px" }}>Templates</div>
              </>
            )}
          </NavItem>
          {isOpen && (
            <Div
              onClick={(e) => {
                e.stopPropagation();
                handleSubMenuClick("templates");
              }}
              cursor="pointer"
              margin="24px 20px 0 20px"
              alignItems="center"
              display="flex"
              color={openSubMenu === "templates" ? globalColor : "#2E2E2E80"}
            >
              {openSubMenu === "templates" ? (
                <FiChevronDown className="svgSize" />
              ) : (
                <FiChevronRight className="svgSize" />
              )}
            </Div>
          )}
        </Div> */}
        {decryptedPermission.manageAdministrationSettings &&
          isTemplateGuideOpen && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                zIndex: 1000,
              }}
              onClick={() => setIsTemplateGuideOpen(false)}
            />
          )}
        <Div
          display="flex"
          width="100%"
          marginLeft={isTemplateGuideOpen ? "24px" : isOpen ? "40px" : "0px"}
          style={
            decryptedPermission.manageAdministrationSettings
              ? { ...getHighlightStyles(isTemplateGuideOpen) }
              : {}
          }
        >
          <Popup
            offset={[-20, 60]}
            content={
              <GetStartedPopup
                // title="Prepare Your Clinical Templates"
                title={
                  step === "23"
                    ? "Sending Intake Forms"
                    : "Prepare Your Clinical Templates"
                }
                description={
                  step === "23" ? (
                    <div>
                      Go to template {">"} Click on shareable template
                      <br />
                      to select the intake forms
                    </div>
                  ) : (
                    <div>
                      Go to Administration {">"} Templates menu to create and
                      assign note templates based on your Specialty and category
                      <br />
                      <div style={{ marginTop: "5px" }}>
                        By doing so you can:
                      </div>
                    </div>
                  )
                }
                bullets={
                  step === "23"
                    ? []
                    : [
                        "Store and manage reusable documentation templates.",
                        "Create custom templates to match your documentation needs.",
                        "Quickly send specific templates to patient to be filled by them.",
                      ]
                }
                currentStep={step === "23" ? 1 : 1}
                totalSteps={step === "23" ? 9 : 8}
                // onNext={() => {
                //   setIsTemplateGuideOpen(false);
                //   window.dispatchEvent(new Event("open1stepPopup"));
                // }}
                onNext={() => {
                  if (step === "23") {
                    setIsTemplateGuideOpen(false);

                    history.replace({
                      pathname: "/settings/templates",
                      search: "?step=23.2",
                    });

                    return;
                  }
                  setIsTemplateGuideOpen(false);
                  history.replace({
                    ...location,
                    state: {
                      ...location.state,
                      showTemplatePopup: undefined,
                    },
                  });
                  window.dispatchEvent(new Event("open2stepPopup"));
                }}
                width="400px"
                onClose={() => {
                  setIsTemplateGuideOpen(false);
                  history.replace({
                    ...location,
                    state: {
                      ...location.state,
                      showTemplatePopup: undefined,
                    },
                  });
                }}
              />
            }
            open={
              decryptedPermission.manageAdministrationSettings &&
              isTemplateGuideOpen
            }
            className="templatepopup m-t-10"
            popperModifiers={[
              { name: "flip", enabled: false },
              { name: "preventOverflow", enabled: true },
            ]}
            trigger={
              <div style={{ width: "100%" }}>
                <NavItem
                  isopen={isOpen ? "true" : "false"}
                  ref={templateGuideRef}
                  to="/settings/templates"
                  color={
                    pathname.includes("/settings/templates")
                      ? globalColor
                      : "#2E2E2E80"
                  }
                  onClick={() => {
                    handleInputChange1("iconclose");
                    setOpenSubMenu("");
                    setIsOpen(false);
                  }}
                >
                  {isOpen ? (
                    <>
                      <MdOutlineViewQuilt size={22} />
                      <Span>Templates</Span>
                    </>
                  ) : (
                    <>
                      <MdOutlineViewQuilt size={22} className="svgSize1" />
                      <div style={{ fontSize: "12px" }}>Templates</div>
                    </>
                  )}
                </NavItem>
              </div>
            }
            position="right center"
          />
          {isOpen && (
            <Div
              onClick={(e) => {
                e.stopPropagation();
                handleSubMenuClick("templates");
              }}
              cursor="pointer"
              margin="24px 20px 0 20px"
              alignItems="center"
              display="flex"
              color={openSubMenu === "templates" ? globalColor : "#2E2E2E80"}
            >
              {openSubMenu === "templates" ? (
                <FiChevronDown className="svgSize" />
              ) : (
                <FiChevronRight className="svgSize" />
              )}
            </Div>
          )}
        </Div>

        <Div
          display="flex"
          width="100%"
          marginLeft={isinsclaimOpen ? "24px" : isOpen ? "40px" : "0px"}
          // paddingRight={isinsclaimOpen && "40px"}
          ref={highlightinsclaim}
          style={
            decryptedPermission.ins_claims && parseInt(accountType) !== 1
              ? { ...getHighlightStyles(isinsclaimOpen) }
              : {}
          }
        >
          <NavItem
            isopen={isOpen ? "true" : "false"}
            to="/billing/nav/1"
            onClick={(e) => {
              if (isOpen) {
                e.preventDefault();
                handleSubMenuClick("billing");
              }
              handleInputChange1("iconopen");
            }}
            color={
              splitLocation[1] === "billing" ||
              (location.pathname === "/" &&
                !storedNames.appt &&
                !storedNames.demo &&
                storedNames.bill)
                ? globalColor
                : "#2E2E2E80"
            }
          >
            {isOpen ? (
              <>
                <IoWalletOutline strokeWidth="0.5" />
                <Span>Billing</Span>
              </>
            ) : (
              <>
                <IoWalletOutline strokeWidth="0.5" />
                <div style={{ fontSize: "12px" }}>Billing</div>
              </>
            )}
          </NavItem>
          {isOpen && (
            <Div
              onClick={() => handleSubMenuClick("billing")}
              cursor="pointer"
              margin="24px 20px 0 20px"
              alignItems="center"
              display="flex"
              color={
                splitLocation[1] === "billing" ||
                (location.pathname === "/" &&
                  !storedNames.appt &&
                  !storedNames.demo &&
                  storedNames.bill)
                  ? globalColor
                  : "#2E2E2E80"
              }
            >
              {openSubMenu === "billing" ? (
                <FiChevronDown className="svgSize" />
              ) : (
                <FiChevronRight className="svgSize" />
              )}
            </Div>
          )}
        </Div>
        {openSubMenu === "billing" && <BillingNav />}
        <Div display="flex" width="100%" marginLeft={isOpen ? "40px" : "0px"}>
          <NavItem
            isopen={isOpen ? "true" : "false"}
            id="rpt_nav-lnk_anch"
            to="/report/nav/1"
            onClick={(e) => {
              if (isOpen) {
                e.preventDefault();
                handleSubMenuClick("report");
              }
            }}
            color={
              splitLocation[1] === "report" ||
              (location.pathname === "/" &&
                !storedNames.appt &&
                !storedNames.demo &&
                !storedNames.bill &&
                storedNames.rep)
                ? globalColor
                : "#2E2E2E80"
            }
          >
            {isOpen ? (
              <>
                <FiFilePlus style={{ color: "inherit" }} />
                <Span>Reports</Span>
              </>
            ) : (
              <>
                <FiFilePlus style={{ color: "inherit" }} />
                <div style={{ fontSize: "12px" }}>Reports</div>
              </>
            )}
          </NavItem>
          {isOpen && (
            <Div
              onClick={() => handleSubMenuClick("report")}
              cursor="pointer"
              margin="24px 20px 0 20px"
              alignItems="center"
              display="flex"
              color={splitLocation[1] === "report" ? globalColor : "#2E2E2E80"}
            >
              {openSubMenu === "report" ? (
                <FiChevronDown className="svgSize" />
              ) : (
                <FiChevronRight className="svgSize" />
              )}
            </Div>
          )}
        </Div>
        {openSubMenu === "report" && <ReportNav />}
        <Div display="flex" width="100%" marginLeft={isOpen ? "40px" : "0px"}>
          <NavItem
            isopen={isOpen ? "true" : "false"}
            to="/settings/nav/1"
            onClick={(e) => {
              if (isOpen) {
                e.preventDefault();
                handleSubMenuClick("settings");
              }
              handleInputChange1("iconopen");
            }}
            // color={splitLocation[1] === "settings" ? globalColor : "#2E2E2E80"}
            color={
              splitLocation[1] === "settings" && !isTemplatesPage
                ? globalColor
                : "#2E2E2E80"
            }
            ref={navItemRef}
          >
            {isOpen ? (
              <>
                <FiSettings style={{ color: "inherit" }} />
                <Span>Settings</Span>
              </>
            ) : (
              <>
                <FiSettings style={{ color: "inherit" }} />
                <div style={{ fontSize: "12px" }}>Settings</div>
              </>
            )}
          </NavItem>
          {isOpen && (
            <Div
              onClick={() => handleSubMenuClick("settings")}
              cursor="pointer"
              margin="24px 20px 0 20px"
              alignItems="center"
              display="flex"
              // color={splitLocation[1] === "settings" ? globalColor : "#2E2E2E80"}
              color={
                splitLocation[1] === "settings" && !isTemplatesPage
                  ? globalColor
                  : "#2E2E2E80"
              }
            >
              {openSubMenu === "settings" ? (
                <FiChevronDown className="svgSize" />
              ) : (
                <FiChevronRight className="svgSize" />
              )}
            </Div>
          )}
        </Div>
        {openSubMenu === "settings" && (
          <SettingsNav
            scrollToTop={scrollToTop}
            setOpenSubMenu={setOpenSubMenu}
            setIsOpen={setIsOpen}
          />
        )}
        <Div marginBottom={isOpen ? "80px" : "20px"}></Div>

        {!isOpen && (
          <Div
            // position="absolute"
            // bottom="14px"
            // left="11px"
            marginTop="auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
              zIndex: 9999,
              pointerEvents: "auto",
              position: "relative",
            }}
          >
            <Div
              ref={headphoneRef}
              style={{
                width: "26px",
                height: "26px",
                backgroundColor: globalColor,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                position: "relative",
              }}
              onMouseEnter={() => {
                setIsHovered(true);
                if (headphoneRef.current) {
                  const rect = headphoneRef.current.getBoundingClientRect();
                  setWidgetPos({
                    top: rect.top - 124,
                    left: rect.right - 30,
                  });
                }
              }}
              onMouseLeave={exploreMouseLeave}
              onClick={() =>
                window.open(
                  "https://calendar.app.google/WdCM1sN5Fg4Es1qm9",
                  "_blank",
                )
              }
            >
              <img
                src={headphoneIcon}
                alt="support"
                style={{
                  width: "28px",
                  height: "28px",
                  objectFit: "contain",
                }}
              />
            </Div>
            <Div
              style={{
                width: "27px",
                height: "27px",
                backgroundColor: globalColor,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                // marginBottom: "12px",
              }}
              onClick={() => {
                window.dispatchEvent(new Event("openUserGuidePopup"));
              }}
            >
              <MdMonitor color="white" size={18} />
            </Div>
          </Div>
        )}
        <ExploreWidget explore="hidden-widget" />
        {isOpen && <ExploreWidget explore="explore-vozo-widget" />}
        {isMembershipPopupOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 50,
            }}
            onClick={() => setIsMembershipPopupOpen(false)}
          />
        )}
      </Nav>
      {/* {billingMembershipNavPopup &&
        billingMembershipNavPopupPosition &&
        typeof document !== "undefined" &&
        ReactDOM.createPortal(
          <div
            className="membership-billing-tour-fixed-popup"
            style={{
              position: "fixed",
              top: `${billingMembershipNavPopupPosition.top}px`,
              left: `${billingMembershipNavPopupPosition.left}px`,
              width: "320px",
              background: "#ffffff",
              borderRadius: "4px",
              border: "1px solid rgba(34, 36, 38, 0.15)",
              boxShadow:
                "0 2px 8px rgba(0, 0, 0, 0.18), 0 1px 3px rgba(0, 0, 0, 0.12)",
              zIndex: 2147483000,
              pointerEvents: "auto",
              overflow: "visible",
            }}
          >
            <div
              className="membership-billing-tour-fixed-popup-arrow"
              style={{
                position: "absolute",
                left: "-8px",
                top: "50%",
                width: "16px",
                height: "16px",
                background: "#ffffff",
                transform: "translateY(-50%) rotate(45deg)",
                boxShadow: "-1px 1px 0 0 rgba(34, 36, 38, 0.12)",
                zIndex: -1,
              }}
            />

            <GetStartedPopup
              title="Billing Membership Plan"
              description="Go to Patient > Membership plan menu to create & assign the membership plan to the patient within the patient demographics."
              currentStep={1}
              totalSteps={8}
              onNext={() => {
                setBillingMembershipNavPopup(false);
                setBillingMembershipNavPopupPosition(null);

                history.replace({
                  pathname: "/patient/membershipplan",
                  search: "?step=billing-membership.2",
                });
              }}
              onClose={() => {
                setBillingMembershipNavPopup(false);
                setBillingMembershipNavPopupPosition(null);
              }}
              width="320px"
            />
          </div>,
          document.body,
        )} */}
      {isHovered && expired_days >= 0 && widgetPos && (
        <div
          style={{
            position: "fixed",
            top: `${widgetPos.top}px`, // ✅ Exact headphone icon level
            left: `${widgetPos.left}px`,
            zIndex: 9999,
            // padding: "10px",
            pointerEvents: "auto",
          }}
          onMouseEnter={exploreMouseEnter}
          onMouseLeave={exploreMouseLeave}
        >
          <ExploreWidget explore="exploreWidgetHover" />
        </div>
      )}
    </>
  );
};

export default SideNav;
